import React from 'react';
import { displayDate } from '../utils/dates';

// Shared Invoice Approval status display (Create Invoices + Invoice Approval), so
// every screen uses the same colors.

const PILL_COLORS = {
  'Approved': { bg: '#dcfce7', fg: '#166534' },
  'Rejected': { bg: '#ffedd5', fg: '#9a3412' },
  'Invoice Not Needed': { bg: '#dcfce7', fg: '#166534' },
  'Need Invoice': { bg: '#fee2e2', fg: '#991b1b' },
};

// Colored pill style for a decision / job flag.
export function approvalPill(decision) {
  const c = PILL_COLORS[decision] || { bg: '#f3f4f6', fg: '#374151' };
  return { fontSize: 11, background: c.bg, color: c.fg, borderRadius: 10, padding: '1px 8px', whiteSpace: 'nowrap' };
}

const cell = { padding: '3px 8px', fontSize: 12, verticalAlign: 'top' };
const head = { ...cell, textAlign: 'left', color: 'var(--gray-600)', fontWeight: 600 };

// Status history rows, newest first (as the server returns them). Only the most
// recent status is color-coded: per invoice, and for the job-level entries —
// older entries are plain text. headers adds a header row.
export function ApprovalHistoryTable({ entries, headers }) {
  const seen = new Set();
  return (
    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
      {headers && (
        <thead><tr>
          <th style={head}>Date</th><th style={head}>Status</th>
          <th style={head}>Reason</th><th style={head}>User</th>
        </tr></thead>
      )}
      <tbody>
        {entries.map((e) => {
          const key = e.invoiceNo || '';
          const latest = !seen.has(key);
          seen.add(key);
          return (
            <tr key={e.entryNo} style={{ borderTop: '1px solid var(--gray-100)' }}>
              <td style={{ ...cell, whiteSpace: 'nowrap', color: 'var(--gray-600)' }}>
                {displayDate(e.effectiveDateTime)}
              </td>
              <td style={{ ...cell, whiteSpace: 'nowrap' }}>
                {latest ? <span style={approvalPill(e.decision)}>{e.decision}</span> : e.decision}
              </td>
              <td style={cell}>{e.reason}</td>
              <td style={{ ...cell, whiteSpace: 'nowrap', color: 'var(--gray-500)' }}>{e.user}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
